<template>
    <div class="Project-Price">
        <div class="Project-Price-Subtotal">
            <span>Netto gesamt</span>
            <span class="Project-Price-Subtotal-Price">
                {{ milestones['Price-Netto'] }}
            </span>
            <span v-if="milestones['Time'] != 0" class="Project-Price-Subtotal-Time">
                {{ milestones['Time-Long'] }}
            </span>
        </div>

        <div v-for="(taxes_value, taxes_key) in
        { '5': milestones['Taxes-5-Long'], '7': milestones['Taxes-7-Long'], '16': milestones['Taxes-16-Long'], '19': milestones['Taxes-19-Long'] }"
            class="Project-Price-Taxes" :class="taxes_value == 0 || taxes_value === undefined ? 'is-empty' : ''">
            <span v-if="taxes_value != 0 && taxes_value !== undefined">USt. {{ taxes_key }}% gesamt</span>
            <span v-if="taxes_value != 0 && taxes_value !== undefined" class="Project-Price--Subtotal-Price">
                {{ taxes_value }}
            </span>
            <span v-if="milestones['Time'] != 0" class="Project-Price-Subtotal-Time"></span>
        </div>

        <div class="Project-Price-Total">
            <span>Brutto gesamt</span>
            <span class="Project-Price-Subtotal-Price">
                {{ milestones['Price-Brutto'] }}
            </span>
            <span v-if="milestones['Time'] != 0" class="Project-Price-Subtotal-Time"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        milestones: {
            type: Object,
            default() {
                return {};
            }
        },
    },
}

</script>

<style lang="scss">
.Project-Price {
    display: grid;
    grid-template-columns: 65% 1fr 1fr;
    gap: 0 5px;
    margin-top: 60px;
    font-size: 10pt;

    .Milestones--noTime + & {
        grid-template-columns: 80% 1fr;
    }

    >div {
        grid-column: span 3;
        display: grid;
        grid-template-columns: subgrid;

        span {
            display: block;
            text-align: right;

            &:first-child {
                text-align: left;
            }
        }
    }

    &-Subtotal {
        border-top: solid 1px black;
        border-bottom: solid 2px black;
        padding: 17px 0;
        margin-bottom: 10px;
    }

    &-Taxes {
        padding: 5px 0;

        &.is-empty {
            padding: 0;
        }
    }

    &-Total {
        padding: 10px 0 5px;
    }
}
</style>



// WEBPACK FOOTER //
// PriceTable.vue?df999e44